import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useMediaQuery} from "react-responsive";
import {Col} from "reactstrap";
import ListView from "../../../components/ContentDisplay/ListView";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import RangePicker from "../../../components/RangePicker";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {requestSystemLogs} from "../../../redux/Actions/controllers.actions";
import {
  getSystemLogs,
  getLogsTotalCount,
  getLogsPaginationUrls,
} from "../../../redux/Selectors/controllers.selectors";
import {useHandleTimeRange} from "../../Dashboard/useHandleTimeRange";
import systemLogsCard from "./systemLogsCard";

const LIST_HEADERS = ["timestamp", "message", "user"];

const Logs = () => {
  const dispatch = useDispatch();
  const isMobileOrTablet = useMediaQuery({query: "(max-width: 1080px)"});
  const [currentPage, setCurrentPage] = useState(1);
  const systemLogs = useSelector(getSystemLogs);
  const logsTotalCount = useSelector(getLogsTotalCount);
  const logsUrls = useSelector(getLogsPaginationUrls);

  const {
    isOpen: isRangePickerOpen,
    onOpen: openRangePicker,
    onClose: closeRangePicker,
  } = useDisclosure();

  const {
    timeRangeOptions,
    timeRangeStart,
    timeRangeStop,
    handleTimeRangeChange,
    handleTimeRangeSave,
  } = useHandleTimeRange(openRangePicker);

  useEffect(() => {
    const params = {timeRangeStart};
    if (timeRangeStop) {
      params.timeRangeStop = timeRangeStop;
    }
    dispatch(requestSystemLogs("", params));
  }, [dispatch, timeRangeStart, timeRangeStop]);

  const handlePageChange = (page) => {
    const url = currentPage < page ? logsUrls?.nextUrl : logsUrls?.prevUrl;
    const params = {timeRangeStart, ...(timeRangeStop && {timeRangeStop})};
    dispatch(requestSystemLogs(url, params));
    setCurrentPage(page);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  return (
    <div style={{margin: isMobileOrTablet ? "0px" : "15px"}}>
      {isRangePickerOpen && (
        <RangePicker
          open={isRangePickerOpen}
          onCloseHandler={closeRangePicker}
          handleSave={handleTimeRangeSave}
          timeZone={"UTC"}
        />
      )}
      <Col className="d-flex justify-content-end">
        <SelectCreator
          id="timeRangeStart"
          colSize={6}
          placeholder={"Look-back period"}
          name="timeRangeStart"
          options={timeRangeOptions}
          value={timeRangeStart}
          onChange={handleTimeRangeChange}
          isSearchable
        />
      </Col>
      <ListView
        listItems={systemLogs}
        listHeaders={LIST_HEADERS}
        totalCount={logsTotalCount}
        withPagination={paginationConfig}
        tableName={"logs"}
        cardContent={systemLogsCard}
      />
    </div>
  );
};

export default Logs;
